import { render } from "./Selectable.vue?vue&type=template&id=50714a8d&scoped=true"
import script from "./Selectable.vue?vue&type=script&lang=js"
export * from "./Selectable.vue?vue&type=script&lang=js"

import "./Selectable.vue?vue&type=style&index=0&id=50714a8d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50714a8d"]])

export default __exports__